import type { Reaction } from '../hooks/useReactions';

interface ReactionDisplayProps {
  reactions: Reaction[];
  onToggle: (emoji: string) => void;
}

export function ReactionDisplay({ reactions, onToggle }: ReactionDisplayProps) {
  if (reactions.length === 0) return null;

  // Group by emoji, count occurrences
  const grouped = new Map<string, { count: number; byUser: boolean }>();
  for (const r of reactions) {
    const existing = grouped.get(r.emoji);
    if (existing) {
      existing.count++;
      if (r.user === 'falco') existing.byUser = true;
    } else {
      grouped.set(r.emoji, { count: 1, byUser: r.user === 'falco' });
    }
  }

  return (
    <div className="reaction-display" aria-live="polite">
      {Array.from(grouped.entries()).map(([emoji, { count, byUser }]) => (
        <button
          key={emoji}
          className={`reaction-pill${byUser ? ' reaction-pill--mine' : ''}`}
          onClick={() => onToggle(emoji)}
          aria-label={`${emoji} ${count}`}
        >
          <span className="reaction-pill__emoji">{emoji}</span>
          {count > 1 && <span className="reaction-pill__count">{count}</span>}
        </button>
      ))}
    </div>
  );
}
